// @flow

"use strict";

import DomUtil from "../util/dom-util";
import URLUtil from "../util/url-util";
import WidgetInview from "../model/common/widget-inview";
import OuterWidget from "../model/outer/outer-widget";
import OuterWidgetAttribute from "../model/outer/outer-widget-attribute";
import UzouGlobal from "../model/outer/uzou-global";
import Placement from "../model/common/placement";
import Environment from "../model/common/environment";
import Device from "../model/common/device";
import User from "../model/common/user";
import OuterDIContainer from "../model/outer/outer-di-container";


/**
 * ハンドラ
 * タグが発火した時点でappendIframeが呼ばれる
 */
export default class OuterWidgetHandler {

  /**
   * タグ発火時にコール。
   * iframeを作成して親Divにappendする
   */
  static appendIframeElement(
      uzouGlobal: UzouGlobal,
      placement: Placement,
      environment: Environment,
      device: Device,
      user: User,
      diContainer: OuterDIContainer,
      window: Window,
      doc: HTMLDocument) {
    // placement_codeとnyクラスで絞り込みウィジェット操作対象DOMを取得する
    const notYetClassName = 'uz-ny'; // uzou not yet
    const alreadyClassName = 'uz-ar'; // uzou already
    const unExecutedWidgetParents = doc.querySelectorAll(`div.uz-${placement.code}.${notYetClassName}`);

    Array.prototype.forEach.call(unExecutedWidgetParents, function (iframeParentDiv: HTMLDivElement) {
      DomUtil.removeClass(iframeParentDiv, notYetClassName); // uz-nyクラスを除去して実行済みWidgetとする
      DomUtil.addClass(iframeParentDiv, alreadyClassName); // 実行済みクラスとしてuzo-arクラスを付与

      const url : string = diContainer.getURLFunction(window, iframeParentDiv);  // placementによってURLの取得方法が変わる可能性があるためDIを利用する

      const referrer: string = URLUtil.getReferer(doc.referrer, environment.akamaiHost);

      const attribute: OuterWidgetAttribute = OuterWidgetAttribute.create(window, doc, iframeParentDiv);

      const inview = new WidgetInview();

      let widget: OuterWidget = OuterWidget.create(placement, environment, device, user, url, referrer, attribute, inview, uzouGlobal.widgets.length);

      DomUtil.addId(iframeParentDiv, widget.id); // widget親Divにidを追加

      uzouGlobal.widgets.push(widget); // グローバル配列にwidgetデータを追加

      const iframe = widget.toIFrameElement(window, doc); // iframe要素を作成

      iframeParentDiv.appendChild(iframe);// 親divにiframe要素をappend
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/handler/outer-widget-handler.js